/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: Type your file description
 * @Author: Type your email address
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-12-02 15:52:26
 * @LastEditTime: 2023-05-18 17:00:42
 * @FilePath: /client-h5-v2/src/theme/zhilian/light1.ts
 */

export default {
  'name': 'zhilianLight1',
  // 默认全局背景色
  'default-global-bg-color': '#3c3b3e',
  // 纯文本颜色
  'kd-text-color': '#434652;',
  'kd-text-hover-color': '#434652;',
  'kd-text-tips-color': '#909399',
  // 链接颜色
  'kd-link-color': '#2EA9FE',
  'kd-link-hover-color': '#2EA9FE',
  'kd-link-active-color': '#2EA9FE',
  // icon 颜色
  'kd-icon-color': '#000000',
  // 按钮
  'kd-btn-text-color': 'rgba(8, 41, 249, 0.6)',
  'kd-btn-text-hover-color': 'rgba(8, 41, 249, 0.7)',
  'kd-btn-bg-color': '#D5EEFF',
  'kd-btn-bg-hover-color': '#b7ddf6',
  'kd-btn-bd-color': '#D5EEFF',
  'kd-btn-bd-hover-color': '#b7ddf6',
  // 顶部导航
  'kd-nav-bg-color': '#ffffff',
  'kd-nav-text-color': '#000000',
  'kd-nav-text-hover-color': '#4a4a4a',
  // 侧边栏
  'kd-slider-nav-bg-color': 'rgba(255, 255, 255, 0.8)',
  'kd-slider-nav-bd-color': 'rgba(255, 255, 255, 0.8)',
  'kd-slider-qlink-text-color': '#000000',
  'kd-slider-qlink-text-hover-color': '#4a4a4a',
  'kd-slider-logo-text-color': '#000000',
  'kd-slider-qlink-bg-color': 'rgba(0,0,0,0)',
  'kd-slider-qlink-bg-hover-color': 'rgba(0,0,0,0)',
  // 对话区域header
  'kd-dialog-header-banner-text-color': '#000000',
  'kd-dialog-header-banner-bg-color': 'rgba(255, 255, 255, 0.4)',
  'kd-dialog-header-banner-bd-color': 'rgba(255, 255, 255, 0.4)',
  // 对话区域middle
  'kd-dialog-middle-bg-color': 'rgba(255, 255, 255, 0.8)',
  'kd-dialog-middle-bd-color': 'rgba(255, 255, 255, 0.8)',
  // 对话区域bottom（input框）
  'kd-input-wrap-bg-color': 'rgba(255, 255, 255, 0)',
  'kd-input-text-color': '#4a4a4a',
  'kd-input-bg-color': 'rgba(255, 255, 255, 0)',
  'kd-input-bd-color': '#AAA7A7',
  'kd-input-bd-hover-color': '#AAA7A7',
  // 对话答案模版
  'kd-template-bg-color': '#D5EEFF',
  'kd-template-text-color': '#000000',
  'kd-template-body-color': '#434652',
  'kd-template-bd-color': '#D5EEFF',
  // send 按钮（对话框主体）
  'kd-send-btn-text-color': '#ffffff',
  'kd-send-btn-bg-color': 'rgba(8, 41, 249, 0.6)',
  'kd-send-btn-bg-hover-color': 'rgba(8, 41, 249, 0.8)',
  'kd-send-btn-bd-color': 'rgba(8, 41, 249, 0.6)',
  'kd-send-btn-bd-hover-color': 'rgba(8, 41, 249, 0.8)',
  'kd-send-tips-text-color': '#AAA7A7',
  // survey模版主题
  'kd-survey-bg-color': '#ffffff',
  'kd-survey-text-color': '#000000',
  // survey模版主题-单选框横向的样式
  'kd-survey-radio-text-color': '#000000',
  'kd-survey-radio-active-text-color': '#000000',
  'kd-survey-radio-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-radio-active-bg-color': '#FFCA7A',
  'kd-survey-radio-bd-color': '#A0A0A0',
  'kd-survey-radio-active-bd-color': '#FFCA7A',
  // survey模版主题-多选框横向的样式
  'kd-survey-checkbox-text-color': '#000000',
  'kd-survey-checkbox-active-text-color': '#000000',
  'kd-survey-checkbox-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-checkbox-active-bg-color': '#FFEBCC',
  'kd-survey-checkbox-bd-color': '#A0A0A0',
  'kd-survey-checkbox-active-bd-color': '#FFEBCC',
  // 智联-survey 客服满意度评价样式
  'kd-survey-zhilian-engineerInfo-bg-color': 'rgba(213, 238, 255, 1)',
  'kd-survey-zhilian-engineerInfo-text-color': 'rgba(8, 41, 249, 1)',
  'kd-user-template-bg-color': '#3F8CFF'
}
